import { render } from "./EntryDialog.vue?vue&type=template&id=4ed482bf&ts=true"
import script from "./EntryDialog.vue?vue&type=script&lang=ts"
export * from "./EntryDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__